<div class="d-flex align-items-center" [class.fill-col]="type === 'edit'">
  <div *ngIf="type === 'edit'">
    <button [class.invisible]="amount === 0" class="button button--secondary button-icon button--xs mx-2" (click)="amount = 0">
      <app-icon anchor="icon-close-xs"></app-icon>
    </button>
  </div>
  <img
    *ngIf="line?.variant?.image && line?.variant?.image?.url"
    [src]="line.variant.image.url"
    [alt]="line.variant.image.altText || line.variant.product?.title"
    class="product-image product-image-ratio order-product-list-item__image"
  />
  <img
    *ngIf="line && !line?.variant?.image?.url"
    [src]="'product-placeholder-afbeelding' | fromDictionary"
    [alt]="line.title"
    class="product-image product-image-ratio order-product-list-item__image"
  />
  <span class="ps-2 ps-md-4" [class.order-list__text-label]="type !== 'edit'">
    <!-- <div *ngIf="type === 'edit'">[LABEL]</div> -->
    <span>{{ line.title }}</span>
    <ng-container *ngIf="type === 'edit' && variant">
      <br />
      <span class="type-body-sm text-muted">
        <span class="cart-line__meta-option" [class.has--seperator]="variant.selectedOptions.length">
          {{ line.quantity }}x
          <ng-container *ngIf="variant.product.metafield as unit">{{ unit.value }}</ng-container>
        </span>

        <span
          *ngFor="let option of variant.selectedOptions; let i = index"
          class="cart-line__meta-option"
          [class.has--seperator]="i !== variant.selectedOptions.length - 1"
        >
          {{ option.value }}
        </span>
      </span>
    </ng-container>
  </span>
</div>
<div class="order-list--hide-mobile">
  <span *ngIf="line">{{ line.variant?.sku || '-' }}</span>
</div>
<div class="order-list--hide-mobile">
  <!-- <span>{{ line.variant.unitPrice?.amount | currency: line.variant.unitPrice?.currencyCode }}</span> -->
  <span>{{ line?.variant?.price?.amount | currency : line?.variant?.price?.currencyCode }}</span>
</div>
<div class="">
  <span *ngIf="type !== 'edit'">{{ line.quantity }}x</span>

  <span *ngIf="type === 'edit' && ((variant && !variant.availableForSale) || maxAvailable <= -1)">
    {{ 'variant-uitverkocht' | fromDictionary }}
  </span>

  <div *ngIf="type === 'edit' && variant && variant.availableForSale && maxAvailable > -1">
    <app-product-amount
      class="d-block"
      [max]="maxAvailable"
      [min]="0"
      [amount]="amount"
      (getSelectedAmount)="amountUpdate($event)"
      [showLabel]="false"
      [showMaxLabel]="true"
    ></app-product-amount>
    <!-- [suffix]="getUnit(product) ?? ''" -->
  </div>
</div>
<div *ngIf="type !== 'edit'">
  <span>
    {{ line.discountedTotalPrice.amount | currency : line.discountedTotalPrice.currencyCode }}
  </span>
</div>
